import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import {
  PENGELOLAAN_KINERJA_NOTIFIKASI_PATH,
  PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
} from 'app/KinerjaShared/constants/path'

type CardUnreadNotificationProps = {
  count: number
  prevRoute?: string
}

export function CardUnreadNotification({
  count,
  prevRoute,
}: CardUnreadNotificationProps) {
  const { trackEvent } = useSKPPelaksanaanTrackEvent()

  if (count < 1) {
    return null
  }

  const resolvedCount = count < 10 ? count : '9+'

  return (
    <Card className="py-3 px-6 flex !flex-row space-x-3 items-center justify-between">
      <div className="space-x-3 flex items-center">
        <div className="w-7 h-7 rounded-full bg-red-60 flex items-center justify-center">
          <Text variant="subheading" color="inverse">
            {resolvedCount}
          </Text>
        </div>
        <Text variant="heading-md">Ada notifikasi baru</Text>
      </div>
      <Link href={PENGELOLAAN_KINERJA_NOTIFIKASI_PATH} passHref>
        <Button
          as="a"
          variant="ghost"
          size="sm"
          color="blue"
          className="!ml-auto items-center"
          aria-label="Cek semua notifikasi"
          type={undefined}
          onClick={() => {
            const isFromKSPenilaian =
              !!prevRoute &&
              prevRoute.includes(PENGELOLAAN_KINERJA_KS_PENILAI_PATH)

            trackEvent({
              activity_type: 'pusat_notifikasi_home_click_notifikasi',
              screen_name: 'pusat_notifikasi',
              event_trigger: isFromKSPenilaian ? 'ks_penilaian_home' : '',
            })
          }}
        >
          Cek{' '}
          <Icon fontSize="sm" color="inherit">
            chevron_right
          </Icon>
        </Button>
      </Link>
    </Card>
  )
}
